class CartRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('cart-recommendations');

        // Check if the fetched recommendations contain a <ul> and if it's empty
        const ul = recommendations ? recommendations.querySelector('ul') : null;
        
        if (ul && ul.children.length > 0) {
          // If <ul> is not empty, update the innerHTML of the original element
          this.innerHTML = recommendations.innerHTML;
          checkUncheckedVariants();
        } else {
          // If <ul> is empty, hide the original <cart-recommendations> element
          this.style.display = 'none';
          checkUncheckedVariants();
        }
      })
      .catch(e => {
        console.error(e);
        // Optionally hide the element on error too, or show a fallback message
        this.style.display = 'none';
      });
  }
}

customElements.define('cart-recommendations', CartRecommendations);
